import update from 'immutability-helper';

import { createReducer } from 'shared/utils/redux';
import { loadingStates, setLoadingStates } from 'shared/constants/redux';
import { createRequestTypes } from 'shared/utils/request';

export const DEVICE_TYPES_FETCH_LIST = createRequestTypes(
  'deviceTypes/FETCH_LIST'
);

export const fetchDeviceTypes = () => ({
  type: DEVICE_TYPES_FETCH_LIST.REQUEST,
  payload: {}
});

const initState = {
  states: loadingStates,
  data: [],
  response: null
};

export default createReducer(initState, {
  [DEVICE_TYPES_FETCH_LIST.REQUEST]: state => {
    return update(state, {
      $merge: {
        states: setLoadingStates({ isLoading: true })
      }
    });
  },
  [DEVICE_TYPES_FETCH_LIST.SUCCESS]: (state, action) => {
    return update(state, {
      $merge: {
        states: setLoadingStates({ isLoaded: true }),
        data: action.payload
      }
    });
  },
  [DEVICE_TYPES_FETCH_LIST.FAILURE]: (state, action) => {
    return update(state, {
      $merge: {
        states: setLoadingStates({ hasError: true }),
        response: action.payload.response
      }
    });
  }
});
